// @ts-strict-ignore
import React, { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Combobox, Box as FormRow, Icon, Input } from '@node-space/ui-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { WalletSortOptions } from 'pages/Wallets/types'
import { WalletType } from 'types/types'
import { useWalletSortOptions } from './hooks/useWalletSortOptions'

interface WalletFilterProps {
  wallets: WalletType[]
  searchQuery?: string
  onSearchTermChange?: React.Dispatch<SetStateAction<string>>
  sortOption: WalletSortOptions
  onSortOptionChanged: React.Dispatch<SetStateAction<WalletSortOptions>>
}

export const WalletFilter = ({
  wallets,
  searchQuery,
  onSearchTermChange,
  sortOption,
  onSortOptionChanged,
}: WalletFilterProps) => {
  const { t } = useTranslation()
  const { enableWalletSorting } = useFeatureFlags()
  const balanceSortOrderOptions = useWalletSortOptions()

  return (
    <FormRow flex gap={12} width={'full'} role="search">
      <Box flexSize="fill">
        <Input
          searchable
          testId="filter-search-field"
          name="filter-search-field"
          type="text"
          aria-label={t('walletsPage.searchPlaceholder')}
          placeholderText={t('walletsPage.searchPlaceholder')}
          onChange={event => onSearchTermChange?.(event.target.value)}
          value={searchQuery || ''}
          iconPosition="right"
          IconButton={
            searchQuery && (
              <Button
                variant="ghost"
                onClick={() => onSearchTermChange?.('')}
                iconElement={<Icon name="X" />}
              />
            )
          }
          {...(!wallets?.length && !searchQuery?.length && { disabled: true })}
        />
      </Box>
      {enableWalletSorting && (
        <Box className="w-[200px]">
          <Combobox
            id="filter-sort-field"
            selectPlaceholder={t('sortBy')}
            testId="filter-sort-field"
            defaultValue={sortOption}
            items={balanceSortOrderOptions}
            onChange={val => onSortOptionChanged(val as WalletSortOptions)}
            filter={false}
            onClear={() => onSortOptionChanged(WalletSortOptions.Empty)}
          />
        </Box>
      )}
    </FormRow>
  )
}
